/**
 * Demo-mode flags on widget config must stay in sync.
 * Legacy widgets used dataMode: 'demo'; newer UI uses forceDemo.
 */

export function isWidgetForceDemo(config = {}) {
  if (!config || typeof config !== 'object') return false;
  return config.forceDemo === true || config.dataMode === 'demo';
}

/**
 * @param {object} config - widget config / display_config
 * @returns {object} normalized copy
 */
export function normalizeWidgetDemoConfig(config = {}) {
  const next = { ...(config && typeof config === 'object' ? config : {}) };
  if (next.forceDemo === false) {
    next.forceDemo = false;
    if (next.dataMode === 'demo') {
      delete next.dataMode;
    }
    return next;
  }
  if (next.forceDemo === true || next.dataMode === 'demo') {
    next.forceDemo = true;
    next.dataMode = 'demo';
  } else {
    next.forceDemo = false;
    if (next.dataMode === 'demo') {
      delete next.dataMode;
    }
  }
  return next;
}
